// extracted by mini-css-extract-plugin
module.exports = {"container":"leadProcessExplaner-module--container--1TLyR","innerContainer":"leadProcessExplaner-module--innerContainer--1MbjS"};